export default "__VITE_ASSET__DtbdSr3M__"